import type { PreloadSources, VideoLayout } from '../player.config';
import type { VideoJsPlayerOptions } from 'video.js';

import { useMemo } from 'react';

import { supportsNativeHls } from '../utils/supports-native-hls';
import '../videojs-poster';

export function useVideoJsOptions(
  maxPlaylistRetries: number,
  looping: boolean,
  muted: boolean,
  aspectRatio?: '16:9' | '4:3',
  videoLayout?: VideoLayout,
  preloadSources?: PreloadSources
): VideoJsPlayerOptions {
  const options: VideoJsPlayerOptions = useMemo(() => {
    const layout = videoLayout || 'fluid';
    return {
      children: ['mediaLoader', 'miPoster', 'liveTracker'],
      html5: {
        hls: {
          overrideNative: !supportsNativeHls(),
          useDevicePixelRatio: true, // Helps with getting better quality in high DPI displays
        },
        vhs: {
          maxPlaylistRetries,
          overrideNative: !supportsNativeHls(),
        },
        nativeTextTracks: supportsNativeHls(),
        nativeAudioTracks: supportsNativeHls(),
      },
      loop: looping,
      muted,
      fluid: layout === 'fluid',
      fill: layout === 'fill',
      playsinline: true,
      disablePictureInPicture: true,
      aspectRatio: layout === 'fluid' ? aspectRatio : undefined,
      preload: preloadSources || 'auto',
    };
  }, [videoLayout, maxPlaylistRetries, looping, muted, aspectRatio, preloadSources]);

  return options;
}
